<template>
  <div>
    <div
      class="kanban-main-cards d-flex"
      style="border-radius: 8px !important"
      :class="candidateDocsUploaded && 'docs-uploaded-border'"
    >
      <div class="w-15 position-relative">
        <div
          class="mr-2"
          :class="
            candidate.customFields &&
            candidate.customFields.imageMedia &&
            candidate.customFields.imageMedia != null
              ? 'common-sm-profile-transparet-icon'
              : 'common-sm-profile-icon'
          "
        >
          <b-avatar
            v-if="
              candidate.customFields &&
              candidate.customFields.imageMedia &&
              candidate.customFields.imageMedia != null
            "
            :src="candidate.customFields.imageMedia"
          ></b-avatar>
          <b-avatar v-else :text="candidate.name[0].toUpperCase()"></b-avatar>
        </div>
        <div
          v-if="candidateDocsUploaded"
          class="
            pushed-cand-dp
            d-flex
            align-items-center
            justify-content-center
          "
          v-b-tooltip.hover.bottom="
            candidate.documentStatus == 3
              ? 'Candidate is yet to submit the documents'
              : 'Document approval is pending'
          "
        >
          <img src="../../assets/img/newkanban/docs-uploaded.svg" alt="" />
        </div>
      </div>
      <div class="w-85">
        <div class="d-flex">
          <div class="w-75 text-truncate kanban-maincards-mainhead">
            {{ candidate.name }}
          </div>
          <div class="w-25 d-flex align-items-center position-relative">
            <img
              v-if="
                selectedCandidate.candidateID == candidate.candidateID &&
                viewCandidateModal
              "
              src="../../assets/img/newcreatejob/hideicon.svg"
              alt=""
              class="pointer"
            />
            <img
              v-else
              :class="isSchedule && 'disabled-kanban-img'"
              @click="!isSchedule && $emit('view-candidate')"
              src="../../assets/img/newkanban/view.svg"
              alt=""
              class="pointer"
            />
            <img
              tabindex="0"
              @click.stop="
                isSchedule || jobOnHold
                  ? ''
                  : selectedID != candidate.candidateID
                  ? selectCand()
                  : closeCand()
              "
              class="ml-2 kanban-image-hover pointer"
              :class="(isSchedule || jobOnHold) && 'disabled-kanban-img'"
              src="../../assets/img/newkanban/more.svg"
              alt=""
            />
            <div
              :ref="'closecard' + candidate.candidateID"
              class="kanban-more-option-card"
              v-if="selectedID == candidate.candidateID"
            >
              <div
                class="kanban-more-option-card-input"
                v-if="
                  !checkShareToClient &&
                  !candidate.kanbanScheduled &&
                  process.type == 'f2f'
                "
                @click="$emit('schedule-interview')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/schedule.svg"
                  class="mr-1"
                  alt=""
                />
                Schedule
              </div>
              <div
                class="kanban-more-option-card-input"
                v-if="checkShareToClient && checkCandToPush"
                @click="$emit('sharetoclient')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/pushcandidate.svg"
                  class="mr-1"
                  alt=""
                />
                Share to Client
              </div>
              <div
                class="kanban-more-option-card-input"
                v-else-if="
                  !checkShareToClient &&
                  !candidate.kanbanScheduled &&
                  process.type == 'assesment'
                "
                @click="$emit('trigger-assessment')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/triggerasmnt.svg"
                  class="mr-1"
                  alt=""
                />
                Trigger Assessment
              </div>
              <div
                class="kanban-more-option-card-input"
                @click="$emit('not-interested')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/ni.svg"
                  class="mr-1"
                  alt=""
                />
                Not Interested
              </div>
              <div
                v-if="
                  candidate.documentStatus == 3 ||
                  candidate.documentStatus == 0 ||
                  candidate.documentStatus == 6
                "
                class="kanban-more-option-card-input"
                @click="closeCand(), $emit('request-docs')"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt=""
                />
                Request Documents
              </div>
              <div
                v-if="
                  candidate.documentStatus == 4 || candidate.documentStatus == 2
                "
                class="kanban-more-option-card-input"
                @click="$emit('goto-viewodcs', candidate.candidateID)"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt=""
                />
                Review Documents
              </div>
              <div
                @click="addAttach = !addAttach"
                :style="
                  addAttach && 'background: rgb(200, 217, 229) !important;'
                "
                class="kanban-more-option-card-input relativeclass"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <img
                      src="../../assets/new-icons/attachment-icon.svg"
                      class="mr-1"
                      alt=""
                    />
                    Add Attachment
                  </div>
                  <img
                    v-if="addAttach"
                    src="../../assets/new-kanban-icons/up-arrow.svg"
                    class="mr-1"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/new-kanban-icons/down-arrow.svg"
                    class="mr-1"
                    alt=""
                  />
                </div>
                <div
                  v-if="addAttach"
                  class="status-dropdown d-flex w-100 px-3 py-2"
                >
                  <div>
                    <img
                      src="../../assets/new-kanban-icons/straight-big-line.svg"
                      alt=""
                    />
                  </div>

                  <!-- status-dropdown-inner-container-selected -- bind this -->
                  <div class="status-dropdown-inner-container ml-2">
                    <div
                      class="status-dropdown-inner-container-unselected"
                      @click="
                        (addAttach = false),
                          $emit('show-add-attachment', candidate)
                      "
                    >
                      Media
                    </div>
                    <div
                      @click="
                        (addAttach = false), $emit('show-add-note', candidate)
                      "
                      class="status-dropdown-inner-container-unselected"
                    >
                      Note
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center w-100">
          <img src="../../assets/img/newkanban/mail.svg" alt="" />
          <div class="w-70 text-truncate kanban-maincards-mailncall ml-1">
            {{ candidate.email }}
          </div>
        </div>
        <div class="mt-1 w-100">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="kanban-maincards-mailncall">
              <img src="../../assets/img/newkanban/phone.svg" alt="" />
              {{ candidate.phoneNumber }}
            </div>
            <div
              class="kanban-maincards-nottriggered"
              v-if="checkShareToClient"
            >
              Not Shared
            </div>
            <div
              style="color: #eb0002"
              class="kanban-maincards-nottriggered"
              v-else-if="
                candidate.documentStatus == 0 || candidate.documentStatus == 6
              "
            >
              Docs Rejected
            </div>
            <div
              :style="'color:#038E00'"
              class="kanban-maincards-nottriggered"
              v-else-if="
                candidate.documentStatus == 4 || candidate.documentStatus == 2
              "
            >
              Review Docs
            </div>
            <div
              :style="'color: #FFC145'"
              class="kanban-maincards-nottriggered"
              v-else-if="candidate.documentStatus == 3"
            >
              Docs Requested
            </div>
            <div
              class="kanban-maincards-nottriggered"
              :style="'color:#20639B'"
              v-else-if="!candidate.kanbanScheduled"
            >
              {{ process.type == "f2f" ? "Not Scheduled" : "Not Triggered" }}
            </div>

            <!-- style bind the color property
            if ongoin and notyetstarted and pending and not evaluated -> #FFC145
            if completed and pass -> #038E00
            scheduled ,not scheduled and not triggered -> #20639B
            not evaluated and fail -> #EB0002

            please note after binding all these classes do remove color from kanban-maincards-nottriggered
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      addAttach: false,
    };
  },
  props: {
    type: String,
    candidate: Object,
    isSchedule: Boolean,
    jobOnHold: Boolean,
    selectedID: String,
    selectedCandidate: Object,
    process: Object,
    vendorRounds: Number,
    candidatesToPush: Number,
    totalPushed: Number,
    viewCandidateModal: Boolean,
    particularJob: Object,
  },
  computed: {
    candidateDocsUploaded() {
      return (
        this.candidate.documentStatus != null &&
        this.candidate.documentStatus != 5
      );
    },
    checkCandToPush() {
      if (this.candidatesToPush == null) {
        return true;
      } else {
        return this.totalPushed < this.candidatesToPush;
      }
    },
    checkShareToClient() {
      if (this.type) {
        if (this.vendorRounds < 1) {
          if (
            this.candidate.documentStatus == 5 ||
            this.candidate.documentStatus == null
          ) {
            return true;
          }
        } else {
          return false;
        }
      }
      return false;
    },
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
    }),
    ...mapGetters({ roles: "roles" }),
    addedByVendor() {
      if (this.particularJob) {
        if (
          this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].addedByVendor
        ) {
          return this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].addedByVendor;
        }
      }
      return false;
    },
  },
  mounted() {
    document.addEventListener("click", this.closeOnOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOnOutside);
  },
  methods: {
    selectCand() {
      this.$emit("select-cand", this.candidate.candidateID);
      this.addAttach = false;
    },
    closeCand() {
      this.$emit("select-cand", "");
    },
    closeOnOutside(event) {
      let id = "closecard" + this.candidate.candidateID;
      if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
        this.$emit("select-cand", "");
        this.addAttach = false;
        // Close the dropdown
      }
    },
  },
};
</script>

<style scoped></style>
